import React from 'react'
import { FormattedMessage } from 'react-intl'

// Components
import Text from '../Text'
import ErrorHeadline from './ErrorHeadline'

const TimeoutMessage = () => (
  <>
    <ErrorHeadline>
      <FormattedMessage id='ErrorBoundary.timeout.headline' defaultMessage='Request timed out...' />
    </ErrorHeadline>
    <Text variant='neutralCool' variantCount='700' size='s' paragraph>
      <FormattedMessage
        id='ErrorBoundary.timeout.message'
        defaultMessage='There was an issue processing this request'
      />
    </Text>
  </>
)

export default TimeoutMessage
